export interface IDialogModel {
  addEventHandler(eventType: DialogEventType, handler: (args: { message: string; origin: string | undefined } | { error: number }) => void): void;
  close(): void;
  messageChild(message: string, messageOptions?: DialogMessageOptions): void;
}

export enum DialogEventType {
  DialogEventReceived = 0,
  DialogMessageReceived = 1,
}
export interface DialogMessageOptions {
  targetOrigin: string;
}
export enum DialogChosenEnum {
  No = 0,
  Yes = 1,
  Cancel = 2,
  ViewOrder = 3
}